import { render, staticRenderFns } from "./AulasAguardandoConfirmacao.vue?vue&type=template&id=1ece470b"
import script from "./AulasAguardandoConfirmacao.vue?vue&type=script&lang=js"
export * from "./AulasAguardandoConfirmacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports